import { useGetInstitutions } from '@vindr/services/actions/institution.action';
import { CaretDownOutlined } from '@vindr/icons';
import { Input, Select } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FILTER_TYPE } from './constants';

const useSearchOptions = (params, handleOnChangeFilter) => {
  const { t } = useTranslation('Vindoc');
  const institutions = useGetInstitutions({ offset: 0, limit: 100 })?.data?.data || [];
  const [open, setOpen] = useState(false);

  const InputItem = (params, key, placeholder = t('Keyword')) => {
    return (
      <Input
        size="small"
        className="w-[200px] max-w-full"
        value={params[key]}
        placeholder={placeholder}
        onChange={(event) => handleOnChangeFilter(params, key, event?.target?.value)}
        onPressEnter={(event) => handleOnChangeFilter(params, key, event?.target?.value, true)}
      />
    );
  };

  return useMemo(
    () => [
      {
        text: t('Group Name'),
        key: FILTER_TYPE.NAME,
        component: InputItem(params, FILTER_TYPE.NAME),
      },
      /* {
        text: t('Status'),
        hidden: false,
        key: FILTER_TYPE.STATUS,
        component: (
          <Filter.Status
            value={params.active}
            title={false}
            renderType="active"
            mode="multiple"
            placeholder={t('Select Status')}
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.STATUS, value, true);
            }}
          />
        ),
      }, */
      {
        text: t('Institution'),
        key: FILTER_TYPE.INSTITUTION,
        component: (
          <Select
            size="small"
            mode="multiple"
            open={open}
            onDropdownVisibleChange={(visible) => setOpen(visible)}
            allowClear
            disabled
            maxTagCount="responsive"
            suffixIcon={<CaretDownOutlined />}
            placeholder={t('Select')}
            className="select-dropdown-light w-[200px] max-w-full"
            popupClassName="dropdown-options-dark"
            onChange={(value) => {
              if (window.innerWidth < 640) {
                setOpen(false);
              }
              handleOnChangeFilter(params, FILTER_TYPE.INSTITUTION, value, true);
            }}
            value={params[FILTER_TYPE.INSTITUTION] || []}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
              option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {institutions
              ? institutions.map((it, idx) => (
                  <Select.Option key={idx} value={it?.id}>
                    {it?.name}
                  </Select.Option>
                ))
              : null}
          </Select>
        ),
      },
    ],
    [t, params, institutions, handleOnChangeFilter]
  );
};

export default useSearchOptions;
